/* global axios */
import ApiClient from './ApiClient';

class AttachmentAPI extends ApiClient {
  constructor() {
    super('attachments', { accountScoped: true });
  }

  get({ page, sort }) {
    return axios.get(`${this.url}?${this.objectToQueryString({ page, sort })}`);
  }

  batchDestroy(ids = []) {
    return axios.delete(`${this.url}/batch_destroy`, {
      data: {
        ids,
      },
    });
  }

  batchDestroyAll() {
    return axios.delete(`${this.url}/batch_destroy_all`);
  }
}

export default new AttachmentAPI();
